export const DEFAULT_HISTORY_FILTERS = {
  creationTimeStart: "",
  creationTimeEnd: "",
  fireRiskRange: [0, 1],
  floodRiskRange: [0, 1],
  earthquakeRiskRange: [0, 1],
};

export const DEFAULT_HISTORY_ORDER = "creation_time:desc";

const toDayBoundaryIso = (dateValue, boundary) => {
  if (!dateValue) return undefined;

  const timeSuffix = boundary === "start" ? "T00:00:00.000Z" : "T23:59:59.999Z";
  const iso = new Date(`${dateValue}${timeSuffix}`).toISOString();

  return Number.isNaN(new Date(iso).getTime()) ? undefined : iso;
};

export const buildHistoryParams = ({
  search,
  orderCombined = DEFAULT_HISTORY_ORDER,
  filters = DEFAULT_HISTORY_FILTERS,
}) => {
  const [orderBy = "creation_time", orderDir = "desc"] = (
    orderCombined || DEFAULT_HISTORY_ORDER
  ).split(":");

  const start = toDayBoundaryIso(filters.creationTimeStart, "start");
  const end = toDayBoundaryIso(filters.creationTimeEnd, "end");

  const [fireRiskStart, fireRiskEnd] = filters.fireRiskRange || [0, 1];
  const [floodRiskStart, floodRiskEnd] = filters.floodRiskRange || [0, 1];
  const [earthquakeRiskStart, earthquakeRiskEnd] =
    filters.earthquakeRiskRange || [0, 1];

  return {
    search: search || undefined,
    orderBy,
    orderDir,
    creationTimeStart: start || undefined,
    creationTimeEnd: end || undefined,
    fireRiskStart: fireRiskStart > 0 ? fireRiskStart : undefined,
    fireRiskEnd: fireRiskEnd < 1 ? fireRiskEnd : undefined,
    floodRiskStart: floodRiskStart > 0 ? floodRiskStart : undefined,
    floodRiskEnd: floodRiskEnd < 1 ? floodRiskEnd : undefined,
    earthquakeRiskStart:
      earthquakeRiskStart > 0 ? earthquakeRiskStart : undefined,
    earthquakeRiskEnd: earthquakeRiskEnd < 1 ? earthquakeRiskEnd : undefined,
  };
};

export const hasValidCoordinates = (assessment) => {
  const lat = Number(assessment?.latitude);
  const lng = Number(assessment?.longitude);
  return Number.isFinite(lat) && Number.isFinite(lng);
};

export const toMarkerInfo = (assessment) => {
  if (!assessment) return null;

  return {
    assessmentId: assessment.id,
    address: assessment.address || "",
    open: true,
    riskData: {
      id: assessment.id,
      latitude: Number(assessment.latitude),
      longitude: Number(assessment.longitude),
      egsa87x: Number(assessment.egsa87x),
      egsa87y: Number(assessment.egsa87y),
      fire: assessment.fire || {},
      flood: assessment.flood || {},
      earthquake: assessment.earthquake || {},
    },
  };
};
